import { render, staticRenderFns } from "./list_questions_kecermatan.vue?vue&type=template&id=365d51cb&scoped=true&"
import script from "./list_questions_kecermatan.vue?vue&type=script&lang=js&"
export * from "./list_questions_kecermatan.vue?vue&type=script&lang=js&"
import style0 from "./list_questions_kecermatan.vue?vue&type=style&index=0&id=365d51cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365d51cb",
  null
  
)

export default component.exports